import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FloorAclEffects } from './floor-acl.effects';
import { floorAclReducer } from './floor-acl.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('floorAcls', floorAclReducer),
    EffectsModule.forFeature([FloorAclEffects]),
  ],
  providers: [],
})
export class FloorAclStoreModule {}
